// Load Styles
import '../scss/main.scss';

// Load Bootstrap init
import {initBootstrap} from "./bootstrap.js";

// Loading bootstrap with optional features
initBootstrap({
  tooltip: true,
  popover: true,
  toasts: true,
});


const questions = [
  {
    "question": "¿Sientes que recibes señales del universo pero no las entiendes?",
    "type": "radio",
    "answer1": "Sí, pero me siento abrumado/a por ellas",
    "answer1Total": "2",
    "answer1Img":"",
    "answer2": "Nunca",
    "answer2Total": "3",
    "answer2Img":"",
    "answer3": "A veces",
    "answer3Total": "4",
    "answer3Img":"",
    "answer4": "Siempre, pero suelo ayudar a otros a interpretarlas",
    "answer4Total": "1",
    "answer4Img":"",
  },
  {
    "question": "¿Qué áreas de tu vida sientes bloqueadas?",
    "type": "checkbox",
    "answer1": "Conexión espiritual y sabiduría",
    "answer1Total": "1",
    "answer1Img":"images/emoji_dizzy symbol_.png",
    "answer2": "Salud",
    "answer2Total": "2",
    "answer2Img":"images/emoji_face with thermometer_.png",
    "answer3": "Dinero",
    "answer3Total": "3",
    "answer3Img":"images/emoji_money with wings_.png",
    "answer4": "Amor",
    "answer4Total": "4",
    "answer4Img":"images/emoji_two hearts_.png",
  },
  {
    "question": "¿Te cuesta tomar decisiones importantes?",
    "type": "radio",
    "answer1": "Poco",
    "answer1Total": "3",
    "answer1Img":"",
    "answer2": "Mucho",
    "answer2Total": "2",
    "answer2Img":"",
    "answer3": "Para nada",
    "answer3Total": "4",
    "answer3Img":"",
    "answer4": "Siento que las decisiones vienen más claras cuando comparto mi perspectiva con otros",
    "answer4Total": "1",
    "answer4Img":"",
  },
  {
    "question": "¿Cómo describirías tu nivel de intuición?",
    "type": "radio",
    "answer1": "Muy alta, pero no sé cómo usarla",
    "answer1Total": "4",
    "answer1Img":"",
    "answer2": "Baja, no confío en ella",
    "answer2Total": "3",
    "answer2Img":"",
    "answer3": "La uso para ayudar a los demás",
    "answer3Total": "1",
    "answer3Img":"",
    "answer4": "Promedio, pero podría mejorar",
    "answer4Total": "2",
    "answer4Img":"",
  },
  {
    "question": "Si pudieras mejorar algo en tu vida ahora mismo, ¿qué sería?",
    "type": "radio",
    "answer1": "Paz mental",
    "answer1Total": "2",
    "answer1Img":"images/emoji_white smiling face_.png",
    "answer2": "Pareja estable",
    "answer2Total": "4",
    "answer2Img":"images/emoji_coupleheart.png",
    "answer3": "Éxito profesional",
    "answer3Total": "3",
    "answer3Img":"images/emoji_briefcase.png",
    "answer4": "Relaciones personales",
    "answer4Total": "1",
    "answer4Img":"images/emoji_dizzy symbol_.png",
  },
  {
    "question": "¿Has intentado técnicas espirituales antes (ej., tarot, astrología)?",
    "type": "checkbox",
    "answer1": "Sí, pero sin resultados claros",
    "answer1Total": "3",
    "answer1Img":"",
    "answer2": "He explorado un poco",
    "answer2Total": "2",
    "answer2Img":"",
    "answer3": "Sí, y siento que me han dado mucha claridad",
    "answer3Total": "4",
    "answer3Img":"",
    "answer4": "No, pero me interesa aprender para poder ayudar a otros",
    "answer4Total": "1",
    "answer4Img":"",
  },
  {
    "question": "¿Qué tan seguido sientes que repites los mismos errores?",
    "type": "radio",
    "answer1": "Poco pero me esfuerzo por aprender de lo que otros hacen",
    "answer1Total": "1",
    "answer1Img":"",
    "answer2": "Rara vez",
    "answer2Total": "4",
    "answer2Img":"",
    "answer3": "A veces",
    "answer3Total": "3",
    "answer3Img":"",
    "answer4": "Muy seguido",
    "answer4Total": "2",
    "answer4Img":"",
  },
  {
    "question": "Si pudieras recibir una señal clara sobre tu futuro, ¿qué te gustaría saber?",
    "type": "checkbox",
    "answer1": "Cómo eliminar todo lo que me bloquea",
    "answer1Total": "2",
    "answer1Img":"",
    "answer2": "Si el amor verdadero está cerca de mí",
    "answer2Total": "4",
    "answer2Img":"",
    "answer3": "Si estoy en el camino correcto para el éxito",
    "answer3Total": "3",
    "answer3Img":"",
    "answer4": "Cómo puedo servir mejor a los demás con mi don",
    "answer4Total": "1",
    "answer4Img":"",
  },
  {
    "question": "¿Qué te gustaría lograr con una guía espiritual?",
    "type": "radio",
    "answer1": "Ayudar a otros a encontrar claridad y vivir de mi intuición",
    "answer1Total": "1",
    "answer1Img":"",
    "answer2": "Amor verdadero y relaciones sanas.",
    "answer2Total": "4",
    "answer2Img":"",
    "answer3": "Abundancia financiera y éxito",
    "answer3Total": "3",
    "answer3Img":"",
    "answer4": "Mi propósito y paz interior",
    "answer4Total": "2",
    "answer4Img":"",
  },
  {
    "question": "¿Cómo te sientes respecto al éxito de los demás?",
    "type": "checkbox",
    "answer1": "Creo que cada éxito de los demás me da pistas para mejorar mi propia vida y la de los demás",
    "answer1Total": "1",
    "answer1Img":"",
    "answer2": "Sé que mi momento llegará, pero no sé cuándo",
    "answer2Total": "3",
    "answer2Img":"",
    "answer3": "Me inspiran, pero siento que estoy atrasado/a",
    "answer3Total": "4",
    "answer3Img":"",
    "answer4": "A veces me comparo y me desmotiva",
    "answer4Total": "2",
    "answer4Img":"",
  },
  {
    "question": "¿Qué tan dispuesto/a estás a aprender algo nuevo?",
    "type": "radio",
    "answer1": "100% para ayudar a mi familia a seguir",
    "answer1Total": "1",
    "answer1Img":"",
    "answer2": "Quiero aprender, pero tengo poco tiempo",
    "answer2Total": "2",
    "answer2Img":"",
    "answer3": "Muy dispuesto/a, estoy listo/a para empezar",
    "answer3Total": "4",
    "answer3Img":"",
    "answer4": "Depende, quiero algo que realmente funcione",
    "answer4Total": "3",
    "answer4Img":"",
  },
  {
    "question": "¿Cuál es tu principal motivación en este momento?",
    "type": "radio",
    "answer1": "Encontrar propósito",
    "answer1Total": "2",
    "answer1Img":"",
    "answer2": "Lograr metas materiales",
    "answer2Total": "3",
    "answer2Img":"",
    "answer3": "Crecer espiritualmente",
    "answer3Total": "4",
    "answer3Img":"",
    "answer4": "Autorealizarme y enseñarle a otros a conseguirlo",
    "answer4Total": "1",
    "answer4Img":"",
  },
  {
    "question": "¿Cómo prefieres aprender algo nuevo?",
    "type": "checkbox",
    "answer1": "Clases prácticas y guías claras.",
    "answer1Total": "3",
    "answer1Img":"",
    "answer2": "Videos inspiradores y motivadores.",
    "answer2Total": "4",
    "answer2Img":"",
    "answer3": "Aprendiendo de las experiencias de la comunidad e instructores",
    "answer3Total": "1",
    "answer3Img":"",
    "answer4": "Exploración personal y a mi propio ritmo",
    "answer4Total": "2",
    "answer4Img":"",
  },
  {
    "question": "¿Cuál de estas frases resuena más contigo?",
    "type": "radio",
    "answer1": '"Todo está conectado."',
    "answer1Total": "1",
    "answer1Img":"",
    "answer2": '“Cada persona tiene su verdad, solo hay que ayudarla a encontrarla”',
    "answer2Total": "2",
    "answer2Img":"",
    "answer3": '"Lo que crees, lo creas."',
    "answer3Total": "3",
    "answer3Img":"",
    "answer4": '"La energía nunca miente."',
    "answer4Total": "4",
    "answer4Img":"",
  },
  {
    "question": "¿Qué tan dispuesto/a estás a cambiar tu vida hoy mismo?",
    "type": "checkbox",
    "answer1": "Estoy lista para ayudar a otros a transformar sus vidas también",
    "answer1Total": "1",
    "answer1Img":"",
    "answer2": "Totalmente dispuesta",
    "answer2Total": "4",
    "answer2Img":"",
    "answer3": "Lo estoy considerando",
    "answer3Total": "3",
    "answer3Img":"",
    "answer4": "Aún no estoy segura",
    "answer4Total": "2",
    "answer4Img":"",
  },
]

const vistasExtras = [
  {
    "img_extra":"",
    "titulo": "¿Qué es Runa?",
    "bajada": "",
    "texto": "En Runa hemos creado la solución definitiva para transformar tu energía, encontrar tu verdadero amor, sanar tus emociones, ser abundante y manifestar los sueños que siempre has tenido en mente a través del tarot, astrología y ocultismo.\n\nAprenderás de gurús que comparten sus secretos contigo a través de clases prácticas, ejercicios guiados, rituales sencillos, manuales de manifestación, ¡100% online!",
    "fuente": "",
    "cta_texto": "Entendido",
  },
  {
    "img_extra":"images/img_extra_01.png",
    "titulo": "65% de los usuarios del tarot",
    "bajada": "aseguran que les ayuda a reflexionar antes de tomar decisiones importantes, proporcionando una nueva perspectiva.",
    "texto": "",
    "fuente": "Fuente: Spiritual Practices User Study, 2022",
    "cta_texto": "Continuar",
  },
  {
    "img_extra":"images/img_extra_02.jpg",
    "titulo": "",
    "bajada": "",
    "texto": '"Estaba estancado en mi vida personal y profesional, pero aprender sobre mi energía y cómo trabajar con herramientas ancestrales fue un cambio total. No solo desbloqueé mi potencial, sino que comencé a manifestar metas que pensé que eran imposibles."',
    "fuente": "Gerardo Muñoz estudio “Conéctate con tu intuición” el 28 de diciembre de 2024",
    "cta_texto": "Siguiente",
  },
  {
    "img_extra":"images/img_extra_03.gif",
    "titulo": "Con Runa, aprenderás a:",
    "bajada": "",
    "texto": "• Descifrar lo que el destino tiene preparado para ti.\n• Descubrir tus fortalezas y superar tus desafíos.\n• Crear una vida llena de claridad, propósito y conexión",
    "fuente": "",
    "cta_texto": "Continuar",
  },
  {
    "img_extra":"images/img_extra_04.gif",
    "titulo": "Con tu suscripción a Runa obtendrás:",
    "bajada": "",
    "texto": "• Nuevos contenidos cada mes.\n\n• Acceso a especialidades como tarot, astrología y registros akáshicos.\n\n• Un solo precio que puedes pagar mensual, trimestral o anualmente.",
    "fuente": "",
    "cta_texto": "Continuar",
  },
  {
    "img_extra":"",
    "titulo": "¿Cómo aprendes con Runa?",
    "bajada": "",
    "texto": "Con Runa, no solo aprenderás tarot o astrología: descubrirás los secretos que culturas milenarias usaron para atraer amor, éxito y abundancia en todas sus formas.\n\n¡Conectarás con energías mágicas que te guiarán hacia un destino espectacular!\n\nSin experiencia previa, y desde la comodidad de tu hogar, empezarás a manifestar tus sueños más audaces.",
    "fuente": "",
    "cta_texto": "Continuar",
  },
  //{
  //  "img_extra":"images/img_extra_04.jpg",
  //  "titulo": "",
  //  "bajada": "",
  //  "texto": '"Tenía tantas dudas y emociones reprimidas que no sabía por dónde empezar. Aquí encontré guía, claridad y la confianza para sanar y crecer. Es increíble cómo pequeñas prácticas pueden transformar toda tu perspectiva. ¡Lo recomiendo totalmente!"',
  //  "fuente": "Angélica Rojas cursó “Cómo sanar mi niña interior” el 04 de octubre de 2024",
  //  "cta_texto": "Continuar",
  //},
]

const resultados = [
  {
    "puntos": "4",
    "img":"images/img_resultado_01_bg.jpg",
    "arquetipo": "Visionario/a",
    "resultado": "Aprende a usar tus dones ocultos para tomar control de tu vida y atraer abundancia. Aprende herramientas como el tarot y la astrología para interpretar las señales del universo.",
    "desc": "👉 Desbloquea tu potencial y transforma tu destino hoy mismo."
  },
  {
    "puntos": "3",
    "img":"images/img_resultado_02_bg.jpg",
    "arquetipo": "Sanador",
    "resultado": "Libera las cargas emocionales que te frenan y encuentra la paz interna. Conéctate con tus raíces y guía a tu niña interior hacia una nueva realidad.",
    "desc": "💡 Sana tu energía y desbloquea tu propósito AHORA."
  },
  {
    "puntos": "2",
    "img":"images/img_resultado_03_bg.jpg",
    "arquetipo": "Alquimista",
    "resultado": "Descubre cómo alinearte con las fuerzas universales para materializar tus metas más ambiciosas. Éxito, amor y abundancia están a tu alcance.",
    "desc": "🔥 Activa tu alquimia interior y comienza tu transformación."
  },
  {
    "puntos": "1",
    "img":"images/img_resultado_04_bg.jpg",
    "arquetipo": "Guía",
    "resultado": "A través de la sabiduría ancestral y la conexión espiritual, te ayudarás a ti mismo y a los demás a encontrar claridad y propósito en la vida. ",
    "desc": "🌟 Despierta tu sabiduría interior y enseña a otros su propósito."
  }
]

let currentQuestion = 0;
let currentExtra = 0;
let currentResult = 0;

let completedViews = 0;

let score = [];
let currentAnswerScore;

const totalQuestions = questions.length;
const totalExtras = vistasExtras.length;

const questionEl = document.querySelector('.question');
const questionType = document.querySelectorAll('.btn-check');
const option1 = document.querySelector('.option1');
const option2 = document.querySelector('.option2');
const option3 = document.querySelector('.option3');
const option4 = document.querySelector('.option4');
const option1img = document.querySelector('.option1-img');
const option2img = document.querySelector('.option2-img');
const option3img = document.querySelector('.option3-img');
const option4img = document.querySelector('.option4-img');
const option1data = document.querySelector('.option1-data');
const option2data = document.querySelector('.option2-data');
const option3data = document.querySelector('.option3-data');
const option4data = document.querySelector('.option4-data');
const nextButton = document.querySelector('.next');

const extraTitulo = document.querySelector('.titulo-extra');
const extraBajada = document.querySelector('.bajada-extra');
const extraTexto = document.querySelector('.texto-extra');
const extraCTA = document.querySelector('.btn-extra');
const extraImg = document.querySelector('.extra-img');
const extraFuente = document.querySelector('.fuente-extra');

const resultadoArquetipo = document.querySelector('.arquetipo');
const resultadoResultado = document.querySelector('.resultado');
const resultadoDesc = document.querySelector('.desc-resultado');
const resultadoImg = document.querySelector('.img-resultado');

let progressBar = document.querySelector('.progress-bar');

const btnEmpezar = document.querySelector('.btn-begin');
const btnResultado = document.querySelector('.btn-resultados');
const btnSub = document.querySelector('.btn-sub');

const startcontainer = document.querySelector('.tc-tp-start');
const questcontainer = document.querySelector('.tc-tp-preguntas');
const questcontainerqs = document.querySelector('.tc-tp-preguntas-cont');
const extraContainer = document.querySelector('.tc-tp-extras');
const resultsContainer = document.querySelector('.tc-tp-resultados');
const subContainer = document.querySelector('.tc-tp-subscribir');
const graciasContainer = document.querySelector('.tc-tp-gracias');

let qCompletado = false;
let isMobile = false;

questcontainer.style.display = 'none';
extraContainer.style.display = 'none';
resultsContainer.style.display = 'none';
subContainer.style.display = 'none';
graciasContainer.style.display = 'none';

function generateQuestions (index) {
  const question = questions[index];
  const option1Total = questions[index].answer1Total;
  const option2Total = questions[index].answer2Total;
  const option3Total = questions[index].answer3Total;
  const option4Total = questions[index].answer4Total;

  questionEl.innerHTML = `${question.question}`

  for (var i=0; i < questionType.length; i++) {
    questionType[i].type = `${question.type}`;
  }

  option1data.setAttribute('data-total', `${option1Total}`);
  option2data.setAttribute('data-total', `${option2Total}`);
  option3data.setAttribute('data-total', `${option3Total}`);
  option4data.setAttribute('data-total', `${option4Total}`);

  option1.innerHTML = `${question.answer1}`
  option1img.src = `${question.answer1Img}`
  option2.innerHTML = `${question.answer2}`
  option2img.src = `${question.answer2Img}`
  option3.innerHTML = `${question.answer3}`
  option3img.src = `${question.answer3Img}`
  option4.innerHTML = `${question.answer4}`
  option4img.src = `${question.answer4Img}`

  completedViews++
}

function generateExtras (index) {
  const vistasExtra = vistasExtras[index];

  extraTitulo.innerHTML = vistasExtra.titulo;
  extraBajada.innerHTML = vistasExtra.bajada;
  extraTexto.innerHTML = vistasExtra.texto;
  extraCTA.innerHTML = vistasExtra.cta_texto;
  extraImg.src = vistasExtra.img_extra;
  extraFuente.innerHTML = vistasExtra.fuente;

  completedViews++
}

function generateResults (index) {

  const resultado = resultados[index];

  resultadoArquetipo.innerHTML = resultado.arquetipo;
  resultadoResultado.innerHTML = resultado.resultado;
  resultadoDesc.innerHTML = resultado.desc;
  resultsContainer.style.backgroundImage = "url('" + resultado.img + "')";
}

btnEmpezar.addEventListener('click', showQuestions);

function showQuestions() {
  generateQuestions(currentQuestion);

  startcontainer.style.display = 'none';
  questcontainer.style.display = 'block';
}

function loadNextQuestion() {
  const selectedOption = document.querySelectorAll('input:checked');

  for (var i=0; i < selectedOption.length; i++) {
    currentAnswerScore = Number(selectedOption[i].nextElementSibling.getAttribute('data-total'));
    selectedOption[i].checked = false;
  }

  score.push(currentAnswerScore);

  if(selectedOption.length === 0) {
    alert('No olvides elegir una opción.');
    return;
  }

  if(currentQuestion === totalQuestions - 1) {
    nextButton.textContent = 'Resultado';

    updateProgress();
    showResults();
    return;
  } else {
    switch (completedViews) {
      case 1:
        showVistaExtra();
        break;
      case 4:
        showVistaExtra();
        break;
      case 8:
        showVistaExtra();
        break;
      case 12:
        showVistaExtra();
        break;
      case 16:
        showVistaExtra();
        break;
      default:
        currentQuestion++;
        generateQuestions(currentQuestion);
        break;
    }
  }

  updateProgress();
}

function showVistaExtra() {
  questcontainer.style.display = 'block';
  questcontainerqs.style.display = 'none';
  extraContainer.style.display = 'block';
  resultsContainer.style.display = 'none';

  generateExtras(currentExtra);

  const extraCTA = document.querySelector('.btn-extra');
  const newExtraCTA = extraCTA.cloneNode(true);
  extraCTA.parentNode.replaceChild(newExtraCTA, extraCTA);

  if(currentExtra === totalExtras - 1) {
    newExtraCTA.addEventListener('click', showSub);
  } else {
    newExtraCTA.addEventListener('click', proceedWithQuiz);
  }

  updateProgress();
}

function proceedWithQuiz() {
  currentQuestion++
  currentExtra++;

  extraContainer.style.display = 'none';
  questcontainerqs.style.display = 'block';

  generateQuestions(currentQuestion);
}

function showResults() {
  const totalScore = score.reduce((a, b) => a + b, 0);
  const averageScore = Math.round(totalScore / score.length);
  console.log(totalScore)
  console.log(averageScore)

  currentResult = Math.min(Math.max(averageScore, 1), 4);

  currentResult = resultados.findIndex(resultado =>
    resultado.puntos === currentResult.toString()
  );

  if (currentResult === -1) currentResult = 0;

  questcontainer.style.display = 'none';
  extraContainer.style.display = 'none';
  resultsContainer.style.display = 'block';

  generateResults(currentResult);
}
function updateProgress() {
  const totalViews = (totalQuestions + totalExtras);

  const progress = (completedViews / totalViews) * 100;

  progressBar.innerText = Math.floor(progress) + "%";
  progressBar.setAttribute('aria-valuenow', Math.floor(progress));
  progressBar.style.width = Math.floor(progress) + "%";

}
function showSub() {
  resultsContainer.style.display = 'none';
  subContainer.style.display = 'block';
}
function showGracias() {
  subContainer.style.display = 'none';
  graciasContainer.style.display = 'block';
}
function initializeQuiz() {
  progressBar.value = 0;
  generateResults(currentResult);
}
initializeQuiz();

nextButton.addEventListener('click', loadNextQuestion);
btnResultado.addEventListener('click', showSub);
btnSub.addEventListener('click', validarSiMail);

function validarSiMail() {
  function valid(mailUser) {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(mailUser);
  }
  const mailUser = document.querySelector("#tc-tp-sub").value;

  if (valid(mailUser) == true) {
    subsAPIInfo();
  } else {
    alert("Debe ingresar un correo electrónico válido.")
    return false;
  }
}

function detectMobile() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];

  return toMatch.some((toMatchItem) => {
    isMobile = true;
    return navigator.userAgent.match(toMatchItem);
  });
}

isMobile = detectMobile();

document.addEventListener("visibilitychange", () => {
  if (document.hidden) {
    if (isMobile == true) {
      sendAPIInfo();
    }
  }
});

// Envio de datos

window.addEventListener("beforeunload", function(){
  if(qCompletado == true) {
    console.log("autodestruir")
  } else {
    sendAPIInfo();
  }
});

function sendAPIInfo() {
  event.preventDefault();
  event.returnValue = true;

  console.log('saved');

  var fechaActual = new Date;
  const fechaFormato =  fechaActual.getFullYear() + "-" + ('0' + (fechaActual.getMonth()+1)).slice(-2) + "-" + ('0' + fechaActual.getDate()).slice(-2) + " " + fechaActual.toLocaleTimeString("es-ES");
  let preguntaActual;

  if(questionEl.innerText == "") {
    preguntaActual = "No se empezó";
  } else {
    preguntaActual = (currentQuestion + 1) + ". " + questionEl.innerText;
  }

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const aMedias = JSON.stringify({
    "created_at": fechaFormato,
    "pregunta": preguntaActual,
    "source": "runa_quiz",
  });

  console.log(aMedias)

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: aMedias,
    redirect: "follow"
  };

  fetch("https://infoapi.multinetlabs.com/api/infoLp", requestOptions)
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.error(error));

  var xhr = new XMLHttpRequest();
  var url = "https://infoapi.multinetlabs.com/api/infoLp";
  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
        var json = JSON.parse(xhr.responseText);
    }
  }
};

function subsAPIInfo() {
  event.preventDefault();
  event.returnValue = true;

  showGracias();

  var fechaActual = new Date;
  const fechaFormato =  fechaActual.getFullYear() + "-" + ('0' + (fechaActual.getMonth()+1)).slice(-2) + "-" + ('0' + fechaActual.getDate()).slice(-2) + " " + fechaActual.toLocaleTimeString("es-ES");
  const mailUser = document.querySelector("#tc-tp-sub").value;
  const resultadoActual = resultadoArquetipo.innerText;

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  qCompletado = true;

  console.log(qCompletado)

  const quizCompletado = JSON.stringify({
    "created_at": fechaFormato,
    "user_id": mailUser,
    "resultado": resultadoActual,
    "source": "runa_quiz",
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: quizCompletado,
    redirect: "follow"
  };

  fetch("https://infoapi.multinetlabs.com/api/infoLp", requestOptions)
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.error(error));

  var xhr = new XMLHttpRequest();
  var url = "https://infoapi.multinetlabs.com/api/infoLp";
  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
        var json = JSON.parse(xhr.responseText);
    }
  }

}
